
<template>
    <div>
        <page-container :top-bar="topBar" :menu="menu"><mars-view class="search" :style="{
            'top': topBarHeight ? topBarHeight + 'px' : '64px'
        }"><mars-form action="javascript:return true"><mars-view class="search-input"><img class="search-input-img" src="https://law-smartapp.cdn.bcebos.com/svg%2Fsug_search_icon.svg"></img><mars-view class="search-input-far"><mars-input focus type="search" class="search-input-far-input" placeholder="请输入法律名词" placeholder-class="search-input-far-placeholder" :value="query" @input="searchSugInput" @confirm="comfirmSug"></mars-input><mars-view v-show="query" class="clear-btn" @click.native.stop="clearQuery"><img class="clear-btn-img" src="https://law-smartapp.cdn.bcebos.com/svg%2Fsug_search_clear.svg"></img></mars-view></mars-view><mars-view class="search-input-close" @click.native.stop="closeQuery">
                    取消
                </mars-view></mars-view></mars-form><mars-view class="search-sug"><mars-view v-for="(item, idx) in sugList" :key="idx" class="search-sug-item" @click.native="chooseSug(item)"><mars-view class="search-sug-item-svg"><img class="search-sug-item-svg-info" src="https://law-smartapp.cdn.bcebos.com/svg%2Fsug_search_icon.svg"></img></mars-view><mars-rich-text class="search-sug-item-center" :nodes="item"></mars-rich-text><mars-view class="search-sug-item-svg"><img class="search-sug-item-svg-info" src="https://law-smartapp.cdn.bcebos.com/svg%2Fsug_left_top__arraw_icon.svg"></img></mars-view></mars-view></mars-view></mars-view></page-container>
    </div>
</template>

<script>
import Container from "../../components/common/container.vue";
import { reqPathTo } from '../../static/utils/env.js';
import { setPageInfoMenu } from '../../static/utils/setPageInfoMenu';
import { nav } from '../../static/utils/navigate';
export default {
  components: {
    'page-container': Container
    // 'c-popup': Popup
  },

  props: {
    topBarHeight: {
      type: String,
      default: '43px'
    }
  },
  data() {
    return {
      autoFocus: true,
      topBar: {
        title: '',
        color: '',
        bgColor: '#fff'
      },
      menu: [],
      query: '',
      sugList: []
    };
  },
  methods: {
    init() {},
    clearQuery() {
      this.query = '';
      // getApp().globalData.codeGroundQuery = '';
      this.sugList = [];
    },
    closeQuery() {
      // this.setQuery(this.oldQuery);
      this.$api.navigateBack({});
    },
    setQuery(query) {
      this.query = query;
      // getApp().globalData.codeGroundQuery = query;
    },

    searchSugInput(e) {
      this.setQuery(e.detail.value);
      this.searchSug();
      // 节流
    },

    searchSug() {
      const query = this.query;
      this.$api.request({
        url: reqPathTo('sug', {}, '', 'law/statutebook'),
        data: {
          query
        }
      }).then(res => {
        let list = res.data.data.sug_list || [];
        this.sugList = list.map(item => {
          item = item.replace(new RegExp(query, 'g'), `<em class="dynamic">${query}</em>`);
          return item;
        });
      });
    },
    comfirmSug(e) {
      // this.query = query;
      // console.log('comfirmSugcomfirmSugcomfirmSugcomfirmSugcomfirmSug', e);
      this.setQuery(e.detail.value);
      getApp().globalData.codeGroundQuery = e.detail.value;
      this.$api.navigateBack({});
    },
    chooseSug(item) {
      // 因为 sug词里面有 <em> 要干掉
      let str = item.replace(/[<em class="dynamic"> | <\/em>]/g, '');
      this.setQuery(str);
      getApp().globalData.codeGroundQuery = str;
      this.$api.navigateBack({});
    }
  },
  created() {
    (function () {
      nav({
        type: 'redirect',
        url: '/pages/error/notFound?fr=searchPage'
      });
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  mounted() {
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  destroyed() {
    (function () {
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      this.$root.$emit("marsPageAfterActivated", this);
    } // 所有query的 操作同步 gloabl
    // const query = getApp().globalData.codeGroundQuery;
    // if (query) {
    //     this.query = query;
    //     this.searchSug();
    // }
    // setPageInfoMenu({title: '律临法律服务_法典搜索'});
    ).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
input[type=search]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
.search {
  padding: 13px 17px;
}
.search .search-input {
  background: #F5F5F5;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  height: 40px;
  align-items: center;
  padding: 0 17px;
  margin-bottom: 5px;
}
.search .search-input .search-input-img {
  width: 16px;
  height: 16px;
  display: block;
}
.search .search-input .search-input-icon {
  color: #CCCCCC;
  font-size: 14px;
}
.search .search-input .search-input-far {
  padding-left: 10px;
  padding-right: 34px;
  flex: 1;
  position: relative;
  height: 100%;
}
.search .search-input .search-input-far .search-input-far-input {
  height: 100%;
  background: #F5F5F5;
  outline: none;
  border: 0;
  font-size: 14px;
}
.search .search-input .search-input-far .search-input-far-placeholder {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #999999;
  letter-spacing: 0;
  line-height: 14px;
}
.search .search-input .search-input-far .clear-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -7px;
  width: 14px;
  height: 14px;
}
.search .search-input .search-input-far .clear-btn .clear-btn-img {
  width: 100%;
  height: 100%;
  display: block;
}
.search .search-input .search-input-close {
  padding-left: 17px;
  border-left: 1px solid #999999;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  line-height: 12px;
}
.search .search-sug-item {
  display: flex;
  justify-content: space-between;
  padding: 15px 0;
  border-bottom: 1px solid #E6E6E6;
}
.search .search-sug-item .search-sug-item-svg {
  width: 18px;
  height: 18px;
}
.search .search-sug-item .search-sug-item-svg .search-sug-item-svg-info {
  width: 100%;
  height: 100%;
  display: block;
}
.search .search-sug-item .search-sug-item-left {
  font-size: 18px;
  color: #CCCCCC;
}
.search .search-sug-item .search-sug-item-center {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #222222;
  letter-spacing: 0;
  line-height: 16px;
  padding-left: 10px;
  flex: 1;
  font-weight: 400;
}
.search .search-sug-item .query-strong,
.search .search-sug-item .dynamic,
.search .search-sug-item /deep/ em {
  color: #445FBB;
  font-weight: 700;
  color: #222222;
  font-family: PingFangSC-Medium;
  text-decoration: none;
  font-style: normal;
}
.search .search-sug-item [class*="dynamic"] {
  color: #445FBB;
  font-weight: 700;
  color: #222222;
  font-family: PingFangSC-Medium;
  text-decoration: none;
  font-style: normal;
}

</style>
